import React from 'react';
import { XCircle } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { notify } from '../services/notify';
import { getPortalUrl } from '../lib/utils';

type ShareDocumentType = 'bill' | 'purchase-order';

export default function ShareDocumentModal({
  document,
  type,
  mode,
  onClose,
}: {
  document: any;
  type: ShareDocumentType;
  mode: 'link' | 'qr';
  onClose: () => void;
}) {
  if (!document) return null;
  const url = getPortalUrl(type, document.id);
  const title = type === 'bill' ? 'Bill' : 'Purchase Order';
  const description = mode === 'qr'
    ? `Scan this QR code with any mobile device to view this ${title.toLowerCase()} live.`
    : `Anyone with this link can view this ${title.toLowerCase()} online.`;

  return (
    <div className="fixed inset-0 bg-primary/60 backdrop-blur-sm z-[220] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-sm overflow-hidden shadow-2xl border border-primary/20">
        <div className="p-6 border-b border-primary/10 flex items-center justify-between">
          <h3 className="text-sm font-bold uppercase tracking-widest italic serif">{mode === 'qr' ? 'Scan QR Code' : 'Share Link'}</h3>
          <button onClick={onClose} className="p-1 hover:bg-primary/5 rounded-full"><XCircle className="w-5 h-5 text-primary/40" /></button>
        </div>
        <div className="p-6 space-y-6">
          <p className="text-xs font-bold text-primary/60 leading-relaxed">{description}</p>
          {mode === 'qr' ? (
            <div className="p-6 bg-white rounded-2xl shadow-inner border border-primary/10 flex items-center justify-center">
              <QRCodeSVG value={url} size={200} level="H" includeMargin />
            </div>
          ) : (
            <div className="relative">
              <input type="text" readOnly value={url} className="w-full bg-white/50 border border-primary/10 rounded-xl px-4 py-3 text-[11px] font-mono pr-20 outline-none font-bold" />
              <button onClick={() => { navigator.clipboard.writeText(url); notify.confirm('Link copied to clipboard'); }} className="absolute right-2 top-1/2 -translate-y-1/2 px-4 py-1.5 bg-primary text-primary-foreground rounded-lg text-[10px] font-bold uppercase tracking-widest">Copy</button>
            </div>
          )}
          {mode === 'qr' && <p className="text-[9px] font-mono text-center font-bold break-all opacity-60">{url}</p>}
          <button onClick={onClose} className="w-full py-4 bg-primary text-primary-foreground font-bold text-xs uppercase tracking-widest rounded-xl">{mode === 'qr' ? 'Done' : 'Close'}</button>
        </div>
      </div>
    </div>
  );
}
